import React from "react";

const Spinner = ({ cover }) => (
    <div className={`spinner ${cover ? "cover" : ""}`}>
        <span className="loader"/>
    </div>
);

export default Spinner;
